import { config } from '@app/config';
import Bugsnag, { Client } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { getApiErrorHttpStatus } from '@mi-front/core';
import React from 'react';

let bugsnagClient: Client;

export function getBugsnagClient(): Client | undefined {
  if (config.isNodeDev) {
    return;
  }

  if (!bugsnagClient) {
    bugsnagClient = Bugsnag.start({
      apiKey: config.bugsnagKey,
      appVersion: config.appVersion,
      releaseStage: config.appEnv,
      enabledReleaseStages: ['prod', 'dev', 'prod-preview', 'production', 'development'],
      enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'process', 'request', 'user'],
      plugins: [new BugsnagPluginReact(React)],
      onBreadcrumb: (bc) => {
        return (
          bc.type !== 'request' || !(bc.metadata as { request: string }).request.match(/socket\.io/)
        );
      },
      onError: (event) => {
        if (event.errors[0].errorMessage.includes('Network Error')) {
          return false;
        }

        // Skip 401 Unauthorized errors (likely from expired JWT tokens)
        if (getApiErrorHttpStatus(event.originalError) === 401) {
          return false;
        }

        // Skip AbortError when play() is interrupted by pause() - this is expected behavior
        if (
          event.errors[0].errorClass === 'AbortError' &&
          event.errors[0].errorMessage.includes(
            'play() request was interrupted by a call to pause()',
          )
        ) {
          return false;
        }
      },
    });
  }

  return bugsnagClient;
}
